"use client";

import { useState, useCallback } from "react";
import { Callback } from "../models";

/**
 *
 * @param {Boolean} val The default value
 *
 * Wraps a boolean in state, providing callbacks for setting the value to true and false.
 *
 * const [isModalShown, showModal, hideModal] = useBoolean(false)
 *
 * <Button onClick={showModal} text="Open Modal" />
 * <Modal open={isModalShown} close={hideModal} />
 */

export default function useBoolean(val: boolean): [boolean, Callback, Callback] {
  const [value, setValue] = useState(val);
  const setTrue = useCallback(() => setValue(true), [setValue]),
    setFalse = useCallback(() => setValue(false), [setValue]);

  return [value, setTrue, setFalse];
}
